const GRAPHQL_TOKEN = window.storefront.token;
const GRAPHQL_URL   = window.storefront.url;
const GRAPHQL_BODY  = (body) => {
    return {
        'async': true,
        'crossDomain': true,
        'method': 'POST',
        'headers': {
        'X-Shopify-Storefront-Access-Token': GRAPHQL_TOKEN,
        'Content-Type': 'application/graphql',
        },
        'body': body
    };
};

const COLOR_SWATCH_QUERY = (handle) => `
    {
        metaobject(handle: {handle: "${handle}", type: "color_swatch"}) {
            handle
            fields {
                value
                key
            }
        }
    }
`;
